import React from 'react';
import { cloneDeep } from 'lodash';
import { assign } from 'xstate';
import { Box } from '@mui/material';

import { MachineContext } from '../../MachineContext';
import { BaseComponent } from '../Component';

import styles from './EmoticonPicker.module.css';

export interface EmoticonPickerComponent extends BaseComponent {
  type: 'emoticonPicker';
  props: EmoticonPickerProps;
}
export interface EmoticonPickerProps {
  emoticonClickHandler: Function;
}
const emoticons = [
  '😀',
  '😃',
  '😄',
  '😁',
  '😆',
  '😅',
  '🤣',
  '😂',
  '🙂',
  '🙃',
  '😉',
  '😊',
  '😇',
  '🥰',
  '😍',
  '🤩',
  '😘',
  '😗',
  '😚',
  '😋',
  '😛',
  '😜',
  '🤪',
  '😝',
  '🤑',
  '🤗',
  '🤭',
  '🤫',
  '🤔',
  '🤐',
  '🤨',
  '😐',
  '😑',
  '😶',
  '😏',
  '😒',
  '🙄',
  '😬',
  '🤥',
  '😌',
  '😔',
  '😪',
  '🤤',
  '😴',
  '😷',
  '🤒',
  '🤕',
  '🤢',
  '🤮',
  '🤧',
  '🥵',
  '🥶',
  '🥴',
  '😵',
  '🤯',
  '🤠',
  '🥳',
  '😎',
  '🤓',
  '🧐',
  '😕',
  '😟',
  '🙁',
  '😮',
  '😯',
  '😲',
  '😳',
  '🥺',
  '😦',
  '😧',
  '😨',
  '😰',
  '😥',
  '😢',
  '😭',
  '😱',
  '😖',
  '😣',
  '😞',
  '😓',
  '😩',
  '😫',
  '🥱',
  '😤',
  '😡',
  '😠',
  '🤬',
];

export const EmoticonPicker: React.FC<EmoticonPickerProps> = ({
  emoticonClickHandler,
}) => {
  return (
    <div>
      <Box
        sx={{
          display: 'flex',
          gap: '10px',
          flexWrap: 'wrap',
          marginBottom: '10px',
          width: '217px',
          height: '194px',
          overflowY: 'auto',
          padding: '16px',
        }}
      >
        {emoticons.map((emoticon) => {
          return (
            <div
              key={emoticon}
              onClick={() => {
                emoticonClickHandler(emoticon);
              }}
              className={styles['emoticon-button']}
            >
              {emoticon}
            </div>
          );
        })}
      </Box>
    </div>
  );
};

export const renderEmoticonPickerAction = () => {
  return assign((context: MachineContext, _event, actionMetadata) => {
    const newContext = cloneDeep(context);
    newContext.widgetData = newContext.widgetData.filter(
      (element) => !element.temporary
    );
    const payload = actionMetadata.action.payload;
    newContext.widgetData.push({
      type: 'emoticonPicker',
      temporary: actionMetadata.action.temporary ?? false,
      props: {
        emoticonClickHandler: payload.emoticonClickHandler,
      },
    });
    return newContext;
  });
};
